
export default function Testimonials() {
  const testimonials = [
    {
      text: '화면이 깨져서 걱정했는데 당일 수리로 새것처럼 돌아왔어요',
      author: '김민수',
      platform: '네이버 리뷰',
      rating: 5,
    },
    {
      text: '15년 경력답게 정말 꼼꼼하게 수리해주셨습니다. 배터리 교체 후 성능이 확실히 좋아졌어요',
      author: '이지은',
      platform: '네이버 리뷰',
      rating: 5,
    },
    {
      text: '다른 곳에서 안된다고 했던 수리를 여기서 해결했습니다. 정말 감사합니다',
      author: '박준호',
      platform: '네이버 리뷰',
      rating: 5,
    },
  ];

  return (
    <section id="testimonials" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-16 items-center mb-20">
          <div>
            <div className="flex items-center gap-2 mb-6">
              <div className="w-2 h-2 bg-[#1a1a1a] rounded-full"></div>
              <span className="text-sm font-medium text-gray-600 uppercase tracking-wider">고객 후기</span>
            </div>

            <div className="relative">
              <div className="text-8xl text-[#007AFF] opacity-20 absolute -top-8 -left-4" style={{ fontFamily: 'Georgia, serif' }}>
                "
              </div>
              <h2 className="text-4xl md:text-5xl font-bold text-gray-900 leading-tight relative z-10" style={{ fontFamily: 'Georgia, serif' }}>
                화면이 깨져서<br />
                걱정했는데 당일 수리로<br />
                새것처럼 돌아왔어요
              </h2>
            </div>

            <div className="mt-8 flex items-center gap-4">
              <div>
                <div className="font-bold text-gray-900 text-base">김민수</div>
                <div className="flex items-center gap-2 mt-1">
                  <div className="flex gap-1">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-yellow-400 text-sm"></i>
                    ))}
                  </div>
                </div>
              </div>
              <div className="ml-auto">
                <a
                  href="https://blog.naver.com/roy1967"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 bg-green-500 text-white px-4 py-2 rounded-full text-sm font-medium cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-chat-3-line"></i>
                  네이버 리뷰
                </a>
              </div>
            </div>
          </div>

          <div className="relative h-96 rounded-3xl overflow-hidden">
            <img
              src="https://public.readdy.ai/ai/img_res/bb278fe37876521d61c6b3e549027bfd.jpg"
              alt="수리용 고배율 현미경"
              className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-500"
            />
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-gray-50 rounded-2xl p-8 hover:shadow-lg transition-all duration-300 transform hover:-translate-y-2"
            >
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400 text-lg"></i>
                ))}
              </div>
              <p className="text-gray-700 text-base leading-relaxed mb-6">
                "{testimonial.text}"
              </p>
              <div className="flex items-center justify-between">
                <div>
                  <div className="font-bold text-gray-900 text-sm">{testimonial.author}</div>
                  <div className="text-gray-500 text-xs mt-1">{testimonial.platform}</div>
                </div>
                <i className="ri-double-quotes-r text-3xl text-[#007AFF] opacity-20"></i>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <a
            href="https://blog.naver.com/roy1967"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-[#007AFF] font-medium hover:underline cursor-pointer whitespace-nowrap"
          >
            더 많은 후기 보기
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
